import { differenceInMinutes } from 'date-fns'

export const getDurationInMinutes = (start: string, end: string) => differenceInMinutes(new Date(end), new Date(start))
